/**
 * MultiSlideBuilder Agent - Intro Section
 * 
 * Provides the agent identity and high-level mission.
 * 
 * Keywords AI Key: MULTI_SLIDE_BUILDER_INTRO
 * Variables: {{planTitle}}, {{slideCount}}, {{sectionCount}}
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { MULTI_SLIDE_BUILDER_PROMPT_KEYS } from './variables';

class MultiSlideBuilderIntroSection extends PromptSectionBase {
    protected readonly keywordsKey = MULTI_SLIDE_BUILDER_PROMPT_KEYS.intro;
    protected readonly fallbackContent = `You are an expert presentation builder specializing in investment banking presentations. Build presentations section by section with professional, dense, and visually compelling slides.

## Your Mission

You orchestrate the complete build process for a presentation from a structured plan:
1. **Iterate through sections** in the plan order
2. **For each section:**
   - Search for reference slides in the style guide
   - Gather research data (AlphaSense, external files, images)
   - Create Excel data if needed (charts, tables)
   - Call ExecuteSectionTool to build the section
3. **Track progress** and handle errors gracefully
4. **Report results** via submitResults when complete

You have access to:
- A style guide presentation with reference slides
- Research agents for gathering content
- Excel editor for creating linked data
- ExecutionAgent (via executeSection) for building slides`.trim();
}

const introSection = new MultiSlideBuilderIntroSection();

/**
 * Get the intro section content.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection(): string {
    return introSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const MULTI_SLIDE_BUILDER_INTRO = introSection.getFallbackContent();
